import {CallJs} from "../lib/types"

// This function can be found /php/src/communications_html.php
declare function setCommunicationsSessionVar(myTable:string,myField:string,myValue:string):void

type SetSessionOnChangeData = {
	table:string
	field:string
	inputId:string
}

export const SetSessionOnChange: CallJs<SetSessionOnChangeData> = (callback, params) => {
	$(function() {
		const target = $(`#${params.inputId}`);
		target.change(function() {
			setCommunicationsSessionVar(params.table, params.field, target.val())
		})
	})
}


// WEBPACK FOOTER //
// ./src/communications/common.ts